import { hashKey, useQuery } from '@tanstack/react-query';

import { BatchTypeEnum, Declaration, IDeclarationGroupsCriteria, SortDirection } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient, STORAGE_KEYS } from '@utils';
import { getStoredCriteria } from '../../criteria.caching';

const defaultDeclarationGroupsCriteria: IDeclarationGroupsCriteria = {
  filters: {
    searchQuery: '',
    statuses: [],
    isExport: (getStoredCriteria(STORAGE_KEYS.COOKIES.BATCH_VIEW) as BatchTypeEnum) === BatchTypeEnum.HIGH_VALUES_EXPORT,
  } as IDeclarationGroupsCriteria['filters'],
  sorting: {
    field: 'createdAt',
    direction: SortDirection.DESC,
  },
  pagination: { page: 1, size: 10, direction: 1, searchToken: '' },
};

export const getInitialCriteria = () => {
  const storedCriteria = getStoredCriteria(STORAGE_KEYS.COOKIES.LIST_DECLARATION_GROUPS_CRITERIA);
  return storedCriteria ?? defaultDeclarationGroupsCriteria;
};

interface FetchGroupsProps {
  filters: any;
  sorting: any;
  pagination: any;
}

export const useDeclarationGroups = (criteria: FetchGroupsProps) =>
  useQuery({
    queryKey: ['declaration-groups', hashKey([criteria])],
    queryFn: async (): Promise<Declaration[]> => {
      const { filters, sorting, pagination } = criteria;
      try {
        const actualFilters = { ...filters, isExport: !!filters.isExport, searchQuery: filters.searchQuery ?? '' };
        const actualPagination: any = {
          page: pagination.page ?? 1,
          direction: pagination.direction ?? 1,
          size: pagination.size,
        };
        if (pagination.searchToken) {
          actualPagination.searchToken = pagination.searchToken;
        }
        const result = await apiClient.declarations.retrieveDeclarationGroups.query({
          query: { criteria: JSON.stringify({ filters: actualFilters, sorting, pagination: actualPagination }) },
        });
        if (result.status !== 200) throw result.body;

        return result.body.data as Declaration[];
      } catch (error) {
        showErrorToast(error, 'Failed to fetch declaration groups');
      }
    },
  });
